import debounce from 'lodash/debounce'

const track = debounce(() => {
  try {
    window._satellite.track('pageview')
  } catch (e) {}
}, 500)

export default () => {
  if (typeof window === 'undefined')
    return {
      digitalData: {
        push: () => {}
      }
    }

  window.digitalData =
    window.digitalData ||
    new (function () {
      this.push = function (value) {
        try {
          for (var x in value) {
            if (typeof this[x] == 'undefined') this[x] = value[x]
            else Object.assign(this[x], value[x])
          }
        } catch (e) {}

        if (value.page) {
          track()
        }
      }
    })()

  return { digitalData: window.digitalData }
}
